import script from "./imageFilter.vue?vue&type=script&setup=true&lang=js"
export * from "./imageFilter.vue?vue&type=script&setup=true&lang=js"

import "./imageFilter.vue?vue&type=style&index=0&id=00b6fb96&lang=less&scoped=true"

import exportComponent from "/home/jenkins/agent/workspace/web-project4knfj/booltool-lite/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-00b6fb96"]])

export default __exports__